import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const dogData = {
  name: "Fluffy",
  gender: "Male",
  age: "5 Months",
  image:
    "https://hips.hearstapps.com/hmg-prod/images/small-dog-breeds-shih-tzu-1583349572.jpg?crop=0.604xw:1.00xh;0.139xw,0&resize=980:*"
};

const AvailableCard = () => {
  const navigate = useNavigate();
  const [selectedDog, setSelectedDog] = useState(null);

  const handleCardClick = () => {
    setSelectedDog(dogData); // Replace with dynamic dog info in real case
  };

  const closeModal = () => {
    setSelectedDog(null);
  };

  return (
    <>
      {/* Adopt Page Button */}
      {/* <button
        className="border px-16 py-2 my-4 bg-green-600 rounded-md text-white font-semibold hover:bg-green-500"
        onClick={() => navigate("/AdoptPage")}
      >
        ADOPT
      </button> */}

      {/* Cards */}
      <div className={`flex flex-wrap justify-center items-center p-4 ${selectedDog ? 'blur-sm' : ''}`}>
        {Array.from({ length: 8 }).map((_, index) => (
          <div
            key={index}
            onClick={handleCardClick}
            className="border shadow-md cursor-pointer m-4 w-60 sm:w-64 md:w-72 lg:w-72 bg-white rounded-md transition-transform hover:scale-105"
          >
            <img
              src={dogData.image}
              alt="Dog"
              className="object-contain w-full rounded-t-md"
            />
            <div className="text-center p-2">
              <h2 className="text-xl font-semibold my-2 text-green-950">Dogs</h2>
              <h3 className="text-lg">{dogData.gender}</h3>
              <h3>{dogData.age}</h3>
              <p className="text-blue-800 cursor-pointer my-4">More About {'->'}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Donate Button */}
      <div>
        <Link to="/page-donate">
          <button className="p-2 px-8 font-semibold rounded-md bg-red-600 text-white border hover:bg-red-500">
            Donate
          </button>
        </Link>
      </div>

      {/* Modal */}
      {selectedDog && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center backdrop-blur-sm ">
          <div className="bg-gray-200 py-12 px-4 rounded-lg shadow-lg w-[95%] h-[90%] max-w-md relative">
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-black text-4xl font-bold"
              onClick={closeModal}
            >
              ✕
            </button>
            <img
              src={selectedDog.image}
              alt="Dog"
              className="rounded-lg w-full object-contain h-48"
            />
            <h2 className="text-2xl font-bold text-center mt-4 text-green-900">{selectedDog.name}</h2>
            <p className="text-center my-2 font-bold">{selectedDog.gender}</p> 
            <p className="text-center mb-4">{selectedDog.age}</p>
            <h1 className='font-bold'>Rate : ₹5000</h1>
            <p className='my-2'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur vitae eveniet perferendis maiores a quod aliquam distinctio et dignissimos accusantium! Tenetur dolorem, ratione quae eligendi adipisci odit perspiciatis natus labore.</p>
            <button
              onClick={() => navigate("/adoption-form")}
              className="block mx-auto px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-500"
            >
              Adopt Now
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AvailableCard;
